import { downloadFile } from 'Utils';
import { PictureAsPdf, FileCopy } from '@material-ui/icons';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import Error from 'Components/Error';

import 'CSS/dashboard-slips.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/demand-supply/demand-supply.scss';

import FileDownload from '../components/FileDownload';
import HiddenLink from '../components/HiddenLink';
import Wrapper from '../components/Wrapper';
import CustomArrowDown from '../components/CustomArrowDown';

class Atachments extends React.PureComponent {
  state = {
    error: null,
  };
  file1 = React.createRef();
  file2 = React.createRef();
  file3 = React.createRef();
  file4 = React.createRef();
  file5 = React.createRef();
  file6 = React.createRef();
  file7 = React.createRef();

  componentDidCatch(error, info) {
    this.setState({ error });
  }

  onDownloadError = error => {
    this.setState({ error });
  };

  onErrorCancel = () => {
    this.setState({ error: null });
  };

  onDownloadFile = downloadFile;

  render() {
    if (!this.props.files.length) return null;
    return (
      <Grid item xs={12} className=" u-pad-top-10 u-pad-bot-10">
        <Error error={this.state.error} onCancel={this.onErrorCancel} />
        <Grid container alignItems="center">
          <Grid item xs={6} className="">
            <h2 className="t-primary-16 t-weight-b u-mrg-bot-10 u-mrg-top-10">
              Atachments
            </h2>
          </Grid>
          <Grid container className="t-primary-14 c-gray-light">
            {this.props.files.map((file, i) => {
              if (file.originalName.endsWith('.pdf')) {
                return (
                  <Grid item xs={12} key={i}>
                    <Wrapper>
                      <HiddenLink
                        download={file.originalName}
                        innerRef={this[`file${i + 1}`]}
                      />
                      <PictureAsPdf />
                      <FileDownload
                        onClick={this.onDownloadFile(
                          file.assetId,
                          this[`file${i + 1}`]
                        )(this.onDownloadError)}
                      >
                        {file.originalName}
                      </FileDownload>
                      <CustomArrowDown />
                    </Wrapper>
                  </Grid>
                );
              }
              return (
                <Grid item xs={12} key={i}>
                  <Wrapper>
                    <HiddenLink
                      download={file.originalName}
                      innerRef={this[`file${i + 1}`]}
                    />
                    <FileCopy />
                    <FileDownload
                      onClick={this.onDownloadFile(
                        file.assetId,
                        this[`file${i + 1}`]
                      )(this.onDownloadError)}
                    >
                      {file.originalName}
                    </FileDownload>
                    <CustomArrowDown />
                  </Wrapper>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default Atachments;
